import $ from "jquery";

export function showDCRFormModal(title, hideModal) {
  $("#dcrFormModal").addClass("show d-block");
  $("#dcrFormTitle").text(title);
  $("#dcrFormClose").on("click", () => {
    hideModal();
  });
  $("#dcrFormHide").on("click", () => {
    hideModal();
  });
}

export function hideDCRFormModal() {
  $("#dcrFormModal").removeClass('show d-block');
}
